const removeCustomPlayIcon = () => videoWrapper.classList.remove('show-custom-play-icon');
const addCustomPlayIcon = () => videoWrapper.classList.add('show-custom-play-icon');

const videoWrapper = document.querySelector('.product-video__video');
const embeddedVideo = videoWrapper.querySelector('iframe');

if(typeof vimeoLoaded !== 'undefined' && vimeoLoaded == true){
   //Check the external Vimeo script is loaded
   const player = new Vimeo.Player(embeddedVideo);
   player.on('play', removeCustomPlayIcon);
   player.on('pause', addCustomPlayIcon); 
}

videoWrapper.addEventListener('click', () => player.play());